<template>
<div class="bg-loginimg">
    <div class="container" id="login-form">
      <div class="row">
        <div class="col-md-4 col-md-offset-4">
          <div class="panel panel-default login-ragis-formstylechen-aftersell">
            <form
              name="form"
              @submit.prevent="HandleSubmit"
              class="form-horizontal"
              id="validate-form"
            >
              <div class="panel-body asloginvew">
                <div class="loginheader">
                  <a href="#" class="login-logo"
                    ><img src="assets/img/logo-dark.png"
                  /></a>
                  <h2>OTP</h2>
                </div>

                <div class="form-group mb-md">
                  <div class="col-xs-12">
                    <div class="input-group">
                      <label for="otp_token">Otp</label>
                      <input
                        v-model="otp_token"
                        v-validate="'required'"
                        type="text"
                        class="form-control"
                        name="otp_token"
                      />
                      <div
                        v-if="errors.has('otp_token')"
                        class="alert alert-danger"
                        role="alert"
                      >
                        OTP is required!
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="panel-footer">
                <div class="clearfix">
                  <button
                    type="submit"
                    class="btn btn-primary submitbtn btn-raised pull-right"
                    :disabled="loading"
                  >
                    <span> OTP </span>
                  </button>
                </div>
                 <div class="form-group">
          <div v-if="message" class="alert alert-danger" role="alert">{{message}}</div>
        </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="copyright">
        <p class="center">
          Copyright 2021, GladMinds Technologies Pvt Ltd. All Right Reserved.
        </p>
      </div>
    </div>
  </div>

</template>

<script>
export default {
    name:'Otp',
    data(){
        return {
            loading: false,
            message: '',
            otp_token:'1111',
        }
    },
    methods: {
      HandleSubmit(){
        this.loading = true;
        this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          this.loading = false;
          return;
        }

        if (this.otp_token) {
          let loader = this.$loading.show();
          this.$store.dispatch('auth/otp_verify', this.otp_token).then(
            (responce) => {
              
              if(!this.$store.state.auth.otp_verify){
                this.$store.commit('set_globalmenues', responce.userdata.GlobalMenues);
                 this.$store.commit('set_username', responce.userdata.first_name+' '+responce.userdata.last_name);
                 this.loading = false;
                 this.$store.commit('set_permission', responce.permission);
                 if(responce.userdata.type == "SP"){
                   this.$store.commit('set_partnerType', responce.My_Brand.type);
                 }
                  loader.hide()
                 if(responce.userdata.redirect){
                    this.$router.push({ name: responce.userdata.redirect })
                 } else {
                    this.$router.replace('admin')
                 }
           
                // console.warn(responce.userdata.GlobalMenues)
              }
            },
            (error) => {
              this.loading = false;
              this.message =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
          setTimeout(() => {loader.hide()}, 1000)
        }
      });
      }
    },
    computed: {
      loggedIn() {
        return this.$store.state.auth.status.loggedIn;
      },
    },
    created(){
      if(this.loggedIn){
        this.$router.replace('admin')
      } else{
        this.$store.commit('SET_LAYOUT', 'simple-layout');
      }
     
    },
    beforeCreate(){
       this.$store.commit('SET_LAYOUT', 'simple-layout');
    },
    destroyed() {
      if(this.loggedIn){
        this.$store.commit('SET_LAYOUT', 'app-layout')
      }
    } 
}
</script>
